import React from 'react';

import * as S from './Shimmer.styles';

const Shimmer = ({
  width,
  height,
  marginLeft,
  marginRight,
  marginBottom,
  marginTop,
  radius,
  customStyle,
  shimmerColor,
  backgroundColor,
}) => {
  return (
    <S.Placeholder
      width={width}
      height={height}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginBottom={marginBottom}
      marginTop={marginTop}
      radius={radius}
      styles={{ ...customStyle }}
      shimmerColor={shimmerColor}
      backgroundColor={backgroundColor}
    />
  )
}

export default Shimmer;
